import CloseIcon from "@components/icons/CloseIcon"
import { isEmpty } from "lodash"
import React from "react"

export const SelectedFirstArea = ({
  selectedAreas,
  handleRemoveArea,
  handleRemoveAreas,
  setShowSearchInput,
}) => {
  if (isEmpty(selectedAreas)) return null

  const [first, ...rest] = selectedAreas

  return (
    <div className="selected-areas-wrap" id="first-selected-area-field">
      <div className="multi-select-box">
        <div className="area-item button button-gray">
          <span>{first.name}</span>

          <CloseIcon bold onClick={() => handleRemoveArea(first)} />
        </div>
        {rest.length > 0 && (
          <div className="area-item button button-gray more-button">
            <span
              onClick={() => {
                setShowSearchInput(true)
              }}
              id="more-areas-button"
            >{`${rest.length} more`}</span>
            <CloseIcon bold onClick={() => handleRemoveAreas(rest)} />
          </div>
        )}
        <button
          onClick={() => {
            setShowSearchInput(true)

            setTimeout(() => {
              const input = document.getElementById("search-input-field")
              input?.focus()
            }, 100)
          }}
          className="add-button"
          id="add-button"
        >
          {" "}
          + Add
        </button>
      </div>
    </div>
  )
}

export const AllSelectedAreas = ({ selectedAreas, handleRemoveArea }) => {
  if (isEmpty(selectedAreas)) return null

  return (
    <div className="all-selected-areas-wrap" id="all-selected-areas">
      {selectedAreas.map((area) => (
        <div
          className="area-item button button-gray"
          key={`${area.slug}-area-item`}
        >
          <span>{area.name}</span>
          <CloseIcon bold onClick={() => handleRemoveArea(area)} />
        </div>
      ))}
    </div>
  )
}
